import { EditableList, ReadingListDetails } from '®shared/reading-list';

import { ListStatus } from './list-status.component';

export function getListStatus(
  list: ReadingListDetails,
  editableList?: EditableList,
): ListStatus | null {
  if (editableList) {
    return getEditableListStatus(editableList);
  }
  return getReadableListStatus(list);
}

function getEditableListStatus(editableList: EditableList): ListStatus {
  if (editableList.hasEverBeenPublished) {
    if (editableList.hasUnpublishedChanges) {
      return ListStatus.publishedWithUnpublishedChanges;
    } else {
      return ListStatus.published;
    }
  } else {
    return ListStatus.draft;
  }
}

function getReadableListStatus(list: ReadingListDetails): ListStatus {
  if (list.is_archived) {
    return ListStatus.archived;
  }
  if (list.hasUnpublishedChanges && list.last_published == null) {
    return ListStatus.draft;
  }
  if (list.last_published != null) {
    return list.hasUnpublishedChanges
      ? ListStatus.publishedWithUnpublishedChanges
      : ListStatus.published;
  }
  return null;
}
